<template>
  <div class="tab-item finance-info">
    <div class="box-item top mb_20">
      <z-collapse :title="$t('loan.cicFee')">
        <ul class="c-list">
          <li><span class="tit">{{$t('loan.poundage')}}：</span><div class="msg">{{ cost.scCurrency }}&nbsp;{{ cost.serviceCharge | formatNum }}</div></li>
          <li><span class="tit">{{$t('loan.agencyFee')}}：</span><div class="msg">{{ cost.afCurrency }}&nbsp;{{ cost.agencyFee | formatNum}}</div></li>
          <li><span class="tit">{{$t('loan.insuranceAgencyPlat')}}：</span><div class="msg">{{ cost.insuranceAgent }}</div></li>
          <li><span class="tit">{{$t('loan.coverAmount')}}：</span><div class="msg">{{ cost.iaCurrency }}&nbsp;{{ cost.insuranceAmount | formatNum}}</div></li>
          <li><span class="tit">{{$t('loan.insuranceFee')}}：</span><div class="msg">{{ cost.ipCurrency }}&nbsp;{{ cost.insurancePremium | formatNum}}</div></li>
        </ul>
      </z-collapse>
<!--      CIC费用  手续费、代理费、保险代理平台、投保金额、保险费-->

      <z-collapse :title="$t('loan.financingInfo')">
        <ul class="c-list rz-list">
          <li><span class="tit">{{$t('loan.financingmount')}} <i>*</i></span><div class="msg">{{ financing.financingCurrency }}&nbsp;{{ financing.financingMoney | formatNum}}</div></li>
          <!--融资金额-->
          <li><span class="tit">{{$t('loan.interestRate')}} <i>*</i></span><div class="msg">{{financing.interestRate}}%</div></li>
          <!--利率-->
          <li><span class="tit">{{$t('loan.interest')}} <i>*</i></span><div class="msg">{{ financing.interestCurrency }}&nbsp;{{ financing.interest | formatNum}}</div></li>
          <!--利息-->
          <li><span class="tit">{{$t('loan.totalCost')}} <i>*</i></span><div class="msg">{{ financing.interestCurrency }}&nbsp;{{ financing.totalCost | formatNum }} </div></li>
          <!--总费用 <span class="warning">（{{$t('loan.cicTotalCost')}}+{{$t('loan.interest')}}）</span>-->
          <li><span class="tit">{{$t('loan.issueCurrency')}} <i>*</i></span><div class="msg">{{financing.grantCurrency}}</div></li>
          <!--发放币种-->
          <li><span class="tit">{{$t('loan.paymentCurrency')}} <i>*</i></span><div class="msg">{{financing.repaymentCurrency}}</div></li>
          <!--还款币种-->
          <li><span class="tit">{{$t('loan.exchangeRate')}}</span><div class="msg">{{financing.exchangeRate}}</div></li>
        </ul>
      </z-collapse>
<!--      融资信息-->

      <time-of-capital class="pb-10" ref="timeCapital"  @confirmClick="confirmUpdate"></time-of-capital>
    </div>

    <div class="box-item" v-if="financing && financing.lockedMoney">
      <fund-lock ref="fundLock" @confirm="confirmUpdate"></fund-lock>

      <z-collapse :title="$t('loan.fundLockAuditRecord')" v-if="this.pagingParm.total">
        <el-table :data="recordList.slice((pagingParm.pageNo-1)*pageSize, pagingParm.pageNo*pageSize)" class="dtl-tb" :class="pagingParm.total>5? '':'pb-20'">
          <el-table-column prop="auditOpinion" :label="$t('loan.auditConclusion')" width="700"></el-table-column>
          <el-table-column prop="auditName" :label="$t('loan.auditName')" width="140"></el-table-column>
          <el-table-column :label="$t('loan.date')" width="180">
            <template slot-scope="scope">{{scope.row.createTime | dateTimeConvert}}</template>
          </el-table-column>
        </el-table>
        <el-pagination class="page-theme text-center pb_25" background layout="prev, pager, next"
                       :total="pagingParm.total" :page-size="pagingParm.pageSize"
                       :current-page.sync="pagingParm.pageNo" v-show="pagingParm.total>5">
        </el-pagination>
      </z-collapse>
<!--      资金锁定审核记录-->
    </div>
  </div>
</template>

<script>
  import ZCollapse from "@/components/ZCollapse";
  import fundLock from "@/components/pageDtl/fundLock";
  import timeOfCapital from "@/components/timeOfCapitalFlow/index";
  export default {
    name: "financeInfo",
    components: {
      ZCollapse,
      fundLock,
      timeOfCapital
    },
    props: {
      financeData: {  // fileVOList
        type: Object,
      },
    },
    data() {
      return {
        pageSize:5,
        // dataObj:this.financeData,
        cost:{}, // cic费用
        financing:{}, // 融资信息

        pagingParm: {
          total: 0,
          pageNo: 1
        },
        recordList:[], // 贸易审核记录 数据
        fundData:[],  // 资金锁定 列表信息
        timeList:[], // 资金出入日期
      }
    },
    // watch:{
    //   financeData(val){
    //     let _this = this;
    //     _this.dataObj = val;
    //   }
    // },

    methods: {
      handleInit(obj){
        // console.log(obj);
        this.cost = obj.cicFinancingCostDraftSnapshot;
        this.financing = obj.zmaFinancingInfo;
        this.recordList = obj.moneyLockLog;
        if(this.recordList){
          this.pagingParm.total = this.recordList.length;
        }

        this.fundData = obj.zmaLockMoneyLogs;
        this.timeList = obj.zmaUpdateTimeLogs;

        this.$nextTick(()=>{
          let fundLockData = {
            logs:this.fundData?this.fundData:[],
            availableBalance:obj.availableBalance, // 可用余额
            isComplete:obj.isComplete // 融资是否完成 完成后不能修改
          };
          this.$refs.fundLock.initData(fundLockData);
          let timeCapitalData = {
            zmaUpdateTimeLogs:this.timeList ? this.timeList:[],  //时间列表
            isComplete:obj.isComplete // 融资是否完成 完成后不能修改
          }
          this.$refs.timeCapital.initData(timeCapitalData);
        })

      }, // 初始化数据
      /**
       *  调整锁定金额成功 回调
       */
      confirmUpdate() {
        this.$emit('update')
      },

    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
.finance-info{
  .c-list{
    padding-bottom: 10px;
  }
  .rz-list{
    padding-bottom: 20px;
  }
}
</style>
